// import React from 'react';
// import { Typography, Space, Button } from 'antd';
// import { BarChartOutlined } from '@ant-design/icons';

// const { Title, Text } = Typography;

// const Reports = () => {
//   return (
//     <div style={{ textAlign: 'center', padding: '40px 0' }}>
//       <BarChartOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '16px' }} />
//       <Title level={4}>Pharmacy Reports</Title>
//       <Text type="secondary" style={{ maxWidth: '500px', margin: '0 auto 24px' }}>
//         Generate inventory reports, prescription analytics, and financial summaries.
//       </Text>
//       <Space>
//         <Button type="primary" ghost>
//           Inventory Report
//         </Button>
//         <Button type="primary" ghost>
//           Prescription Analytics
//         </Button>
//         <Button type="primary" ghost>
//           Financial Summary
//         </Button>
//       </Space>
//     </div>
//   );
// };

// export default Reports;



import React from 'react';
import { Typography, Space, Button } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Reports = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', padding: '40px 0' }}>
      <BarChartOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '16px' }} />
      <Title level={4}>Pharmacy Reports</Title>
      <Text type="secondary">
        Generate inventory reports, prescription analytics, and financial summaries.
      </Text>
      <br /><br />
      <Space>
        <Button type="primary" ghost onClick={() => navigate('/reports/inventory')}>
          Inventory Report
        </Button>
        {/* <Button type="primary" ghost onClick={() => navigate('/reports/analytics')}>
          Prescription Analytics
        </Button>
        <Button type="primary" ghost onClick={() => navigate('/reports/financial')}>
          Financial Summary
        </Button> */}
      </Space>
    </div>
  );
};

export default Reports;
